import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import CustomPropTypes from '../../../../../common/util/CustomPropTypes';
import PropTypes from 'prop-types';
import { View } from '@instructure/ui-view';
import NumberInput from '@instructure/quiz-number-input';
import t from '@instructure/quiz-i18n/format-message';
import { withI18nSupport } from '@instructure/quiz-common';
var ExtraTimeMultiplier = /*#__PURE__*/function (_withI18nSupport) {
  function ExtraTimeMultiplier() {
    var _this2;
    _classCallCheck(this, ExtraTimeMultiplier);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, ExtraTimeMultiplier, [].concat(args));
    _defineProperty(_this2, "onChangeMultiplier", function (e, multiplierString, normalizedValue) {
      var fromButtonInput = e.nativeEvent.target && e.nativeEvent.target.tagName !== 'INPUT';
      var fromArrowKeys = e.key === 'ArrowUp' || e.key === 'ArrowDown';
      var normalizeOnChange = fromButtonInput || fromArrowKeys;
      var shouldUpdateMessage = e.type !== 'blur';
      var messages = shouldUpdateMessage ? null : _this2.state.multiplierMessages;
      var aboveMax = normalizedValue > _this2.props.maxMultiplier;
      var belowMin = normalizedValue < _this2.props.minMultiplier;
      var outOfRange = aboveMax || belowMin;
      if (normalizeOnChange && outOfRange) {
        // Don't allow the up-button or down-button to take us out of range
        _this2.onBlurMultiplier();
        return;
      }
      if (multiplierString !== '') {
        if (normalizedValue === null) {
          var messageText = t('{userInput, string} is not a valid number.', {
            userInput: multiplierString
          });
          messages = [{
            type: 'error',
            text: messageText
          }];
        } else if (normalizedValue > _this2.props.maxMultiplier) {
          var _messageText = t('{userInput, string} is above the maximum of {max, number}', {
            userInput: multiplierString,
            max: _this2.props.maxMultiplier
          });
          messages = [{
            type: 'error',
            text: _messageText
          }];
        } else if (normalizedValue < _this2.props.minMultiplier) {
          var _messageText2 = t('{userInput, string} is below the minimum of {min, number}', {
            userInput: multiplierString,
            min: _this2.props.minMultiplier
          });
          messages = [{
            type: 'error',
            text: _messageText2
          }];
        }
      }
      var update = {
        rawMultiplierValue: multiplierString,
        multiplierMessages: messages
      };
      if (normalizedValue !== null) {
        var valueToUpdate = normalizedValue;
        valueToUpdate = aboveMax ? _this2.props.maxMultiplier : valueToUpdate;
        valueToUpdate = belowMin ? _this2.props.minMultiplier : valueToUpdate;
        update.normalizedMultiplierValue = valueToUpdate;
      }
      _this2.setState(update);
    });
    _defineProperty(_this2, "onBlurMultiplier", function () {
      _this2.setState({
        rawMultiplierValue: _this2.formatDecimal2FractionDigits(_this2.state.normalizedMultiplierValue)
      });
      _this2.props.onChange(Number(_this2.state.normalizedMultiplierValue));
    });
    return _this2;
  }
  _inherits(ExtraTimeMultiplier, _withI18nSupport);
  return _createClass(ExtraTimeMultiplier, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var multiplierValue = Math.max(this.props.timerMultiplierValue, this.props.minMultiplier);
      var multiplierValueString = this.formatDecimal2FractionDigits(multiplierValue);
      this.setState({
        rawMultiplierValue: multiplierValueString,
        normalizedMultiplierValue: multiplierValue
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(View, {
        display: "block"
      }, /*#__PURE__*/React.createElement(NumberInput, {
        renderLabel: t('Time limit multiplier'),
        step: 0.01,
        value: this.state.rawMultiplierValue,
        onChange: this.onChangeMultiplier,
        onBlur: this.onBlurMultiplier,
        decimalPrecision: 2,
        messages: this.state.multiplierMessages,
        "data-automation": "sdk-moderation-time-multiplier"
      }));
    }
  }]);
}(withI18nSupport(Component));
_defineProperty(ExtraTimeMultiplier, "propTypes", {
  onChange: PropTypes.func.isRequired,
  timerMultiplierValue: PropTypes.string.isRequired,
  maxMultiplier: PropTypes.number.isRequired,
  minMultiplier: CustomPropTypes.numberInRange(1, Infinity),
  locale: PropTypes.string
});
_defineProperty(ExtraTimeMultiplier, "defaultProps", {
  minMultiplier: 1,
  locale: null
});
_defineProperty(ExtraTimeMultiplier, "contextTypes", {
  locale: PropTypes.string
});
export default ExtraTimeMultiplier;